import { eventBus } from '../utils/eventBus';
import { overrideChabotConfiguration } from './settingOverride';
import { authenticateUser } from './userAuthentication';
import { isFirefox } from '../CACTA/JSComponents/JS/helper';
import { initiateCAChat } from '../CACTA/JSComponents/JS/eventManagement';
import { getCAConfig } from '../utils/ca-env';
import { showChatChipOnInit } from '../CACTA/JSComponents/HTML/CAButton';

export const _initChatByEvent = (data) => {
  console.log('_initChatByEvent', { data });
  if (typeof window !== 'undefined' && window.document && !window.caSFScript) {
    if (!window.embedded_svc) {
      let scriptURL;
      const { env } = getCAConfig();
      if (env === 'production')
        scriptURL = 'https://chat-anywhere.care.vpsvc.com/caretech-assets/embeddedservice.esw.min.js';
      else
        scriptURL = 'https://chat-anywhere-staging.care-staging.vpsvc.com/caretech-assets/embeddedservice.esw.min.js';
      var s = document.createElement('script');
      // Original caretech CDN url is replaced with CA S3 | VIR-2533
      s.setAttribute('src', scriptURL);
      window.caSFScript = true;
      s.onload = function () {
        window.embedded_svc.isCACTAClicked = true;
        window.embedded_svc.isDragStarted = false;

        initESW(null, data);
      };
      document.body.appendChild(s);
    } else {
      window.embedded_svc.isCACTAClicked = true;
      window.embedded_svc.isDragStarted = false;

      initESW(null, data);
    }
    const showSkiplink = showChatChipOnInit();
    console.log('showChatChipOnInit result:', showSkiplink);
    let tabPressCount = 0;
    document.addEventListener('keydown', (e) => {
      console.log('Keydown event detected:', e.key);
      if (!showSkiplink) {
        console.log('Skip link is not shown, returning');
        return;
      }

      if (e.key === 'Tab') {
        tabPressCount++;
        console.log('Tab key pressed, count:', tabPressCount);
        setTimeout(() => {
          const chatBtn = document.getElementById('caHelpButton');
          const skipLinkContainer = document.querySelector('[href="#maincontentstart"]')?.parentElement;

          console.log('Active element:', document.activeElement);
          const activeElement = document.activeElement;
          const isInteractiveElement =
            activeElement &&
            (activeElement.tagName === 'BUTTON' ||
              activeElement.tagName === 'INPUT' ||
              activeElement.tagName === 'TEXTAREA' ||
              activeElement.tagName === 'SELECT');

          if (
            tabPressCount == 2 &&
            showSkiplink &&
            !isInteractiveElement &&
            chatBtn &&
            skipLinkContainer &&
            !document.getElementById('skipToChatLink')
          ) {
            console.log('Creating skip link...');
            const skipToChat = document.createElement('a');
            skipToChat.id = 'skipToChatLink';
            skipToChat.className = 'swan-skip-link';
            skipToChat.style.zIndex = '10000';
            skipToChat.href = '#chatbtn';
            skipToChat.textContent = 'Skip to Chat';

            skipToChat.addEventListener('click', (event) => {
              console.log('Skip to Chat link clicked');
              event.preventDefault();
              chatBtn.focus();
            });

            skipLinkContainer.appendChild(skipToChat);
            console.log('Skip link appended to container');
            skipToChat.focus();
          }
        }, 0);
      }
    });
  }
};
export const _cutomButtonClicked = (data) => {
  console.log('_cutomButtonClicked', { data });
  if (window.embedded_svc) embedded_svc.onHelpButtonClick();
  //embedded_svc.bootstrapEmbeddedService()
};

var initESW = async function (gslbBaseURL, data) {
  // Changing gslbaseurl for firefox session continuation
  if (isFirefox()) {
    gslbBaseURL = 'https://service.force.com';
  }
  embedded_svc = await overrideChabotConfiguration(embedded_svc, data);
  //Method to check that if user is already logged on VistaPrint site
  authenticateUser(embedded_svc, gslbBaseURL);

  const caChatConfig = getCAConfig();
  const isLightningEnabled = caChatConfig.loadLightningScript;
  if (isLightningEnabled) {
    loadLightninghScript();
  }
};

function loadLightninghScript() {
  // Adding preloading here-----
  const caChatConfig = getCAConfig();
  const url = caChatConfig.baseCoreURL;
  let _script = document.createElement('script');
  _script.type = 'text/javascript';
  _script.src = url + '/lightning/lightning.out.js';
  _script.onload = function () {
    eventBus.on('HPOpenChat', (data) => initiateCAChat(data));
    eventBus.dispatch('CALoaded');
  };
  document.getElementsByTagName('head')[0].appendChild(_script);
}
